{
  "common": {
    "next": "Dalej",
    "previous": "Wstecz",
    "cancel": "Anuluj",
    "save": "Zapisz",
    "reset": "Resetuj",
    "close": "Zamknij"
  },

  "nav": {
    "home": "Strona Główna",
    "about": "O nas",
    "faq": "FAQ",
    "contact": "Kontakt",
    "order": "Zamów Teraz",
    "orderStatus": "Status zamówienia",
    "terms": "Regulamin",
    "privacy": "Polityka Prywatności",
    "delivery": "Informacje o dostawach"
  },

  "footer": {
    "tagline": "Borówka Premium uprawiana z miłością i pasją od 1994.",
    "links": "Linki",
    "contact": "Kontakt",
    "hours": "Godziny otwarcia",
    "weekdays": "Poniedziałek - Piątek:",
    "saturday": "Sobota:",
    "sunday": "Niedziela:",
    "harvestSeason": "Czas trwania zbiorów: Lipiec - Wrzesień",
    "rights": "\u00a9 2026 BorowkaSzczecin. Wszelkie prawa zastrzeżone."
  },

  "cookie": {
    "message": "Ta strona używa plików cookies, aby zapewnić jak najlepsze działanie serwisu. Korzystając ze strony, wyrażasz zgodę na ich stosowanie. Więcej informacji znajdziesz w naszej",
    "privacyPolicy": "Polityce Prywatności",
    "decline": "Odrzuć",
    "accept": "Akceptuję"
  },

  "hero": {
    "title": "Świeże",
    "titleHighlight": "Borówki",
    "subtitle": "Świeże, soczyste i słodkie borówki amerykańskie prosto z pola \u2013 zamów już dziś i ciesz się smakiem lata!",
    "orderNow": "Zamów Teraz",
    "explorePlantation": "Poznaj Plantację"
  },

  "about": {
    "sectionTitle": "Nasza Plantacja Borówek",
    "sectionSubtitle": "Od 1994 roku z pasją i zaangażowaniem w jakość uprawiamy borówkę wysoką.",
    "historyTitle": "Nasza historia",
    "historyP1": "Od prawie trzech dekad uprawiamy borówkę w naszym rodzinnym gospodarstwie. To, co zaczęło się jako małe gospodarstwo, przekształciło się w renomowaną plantację, znaną z wyjątkowej dbałości o jakość i smak owoców.",
    "historyP2": "Jesteśmy dumni z naszych zrównoważonych praktyk rolniczych, łączymy naturę z nowoczesnymi rozwiązaniami technologicznymi, pozwalającymi nam uprawiać zdrowe, pyszne i bogate w składniki odżywcze owoce. Każda kobiałka naszych borówek przechodzi rygorystyczną kontrolę jakości, abyście otrzymali tylko to, co najlepsze.",
    "premiumQuality": "Jakość Premium",
    "premiumQualityDesc": "Ręcznie zbierane borówki",
    "organic": "100% Świeżości",
    "organicDesc": "Dostawa owoców w dniu zbioru",
    "bestTaste": "Najlepsza w smaku",
    "bestTasteDesc": "Bogactwo antyoksydantów i intensywny aromat",
    "customerFavourite": "Uwielbiana przez klientów",
    "customerFavouriteDesc": "Oceniane na {rating}\u2605"
  },

  "howToOrder": {
    "title": "Jak złożyć zamówienie?",
    "subtitle": "To proste.",
    "step1": "Kliknij przycisk {button}.",
    "step2": "Wybierz sposób odbioru: {delivery} lub {pickup} na plantacji.",
    "step3": "Podaj dane osobowe, adres dostawy i formę płatności.",
    "step4": "Oczekuj dostawy w najbliższym czasie.",
    "orderNow": "Zamów Teraz"
  },

  "whyUs": {
    "title": "Dlaczego nasze borówki?",
    "natural": "Naturalna uprawa",
    "naturalDesc": "Prosto z torfowiska, ściółkowane zrębką",
    "local": "Lokalna produkcja",
    "localDesc": "Wspierasz małe gospodarstwo w Twoim regionie.",
    "direct": "Bezpośrednio z pola",
    "directDesc": "Borówki zbieramy ręcznie i od razu pakujemy.",
    "health": "Zdrowie i smak",
    "healthDesc": "Bogactwo antyoksydantów i intensywny aromat."
  },

  "reviews": {
    "title": "Opinie klientów",
    "summary": "{rating} \u2605 \u00b7 {count} opinii",
    "previous": "Poprzednia opinia",
    "next": "Następna opinia",
    "goTo": "Przejdź do opinii {index}"
  },

  "faq": {
    "title": "FAQ",
    "subtitle": "Tutaj znajdziesz odpowiedzi na swoje pytania.",
    "priceUnavailable": "Aktualna cena borówek jest dostępna w formularzu zamówienia i w kontakcie telefonicznym.",
    "items": [
      {
        "question": "Jakie są ceny borówek?",
        "answer": "Borówke pakujemy w 1 kg kartonowe pudełko. Aktualna cena wynosi {price} zł za kg."
      },
      {
        "question": "Ile trwa dostawa?",
        "answer": "Zamówienia staramy się dostarczać codziennie, zazwyczaj w godzinach wieczornych."
      },
      {
        "question": "Czy borówki są mrożone?",
        "answer": "Nie, nasze borówki są świeże \u2013 zbieramy je i pakujemy ręcznie tego samego dnia."
      },
      {
        "question": "Co to są samozbiory?",
        "answer": "Samozbiory to możliwość samodzielnego zbierania borówek na plantacji przez klientów."
      },
      {
        "question": "Kiedy będą samozbiory?",
        "answer": "Samozbiory rozpoczynają się w drugiej połowie lipca i trwają do końca sierpnia."
      }
    ]
  },

  "gallery": {
    "title": "Galeria",
    "imageAlt": "Plantacja borówek"
  },

  "localization": {
    "title": "Gdzie nas znajdziesz?",
    "subtitle": "Nasza plantacja znajduje się w Pilchowie"
  },

  "contact": {
    "title": "Kontakt",
    "message": "Masz pytania? Napisz do nas:",
    "or": "lub zadzwoń:"
  },

  "thankyou": {
    "title": "Dziękujemy za złożenie zamówienia!",
    "subtitle": "Twoje zamówienie zostało przyjęte i jest w trakcie realizacji.",
    "paymentPaidTitle": "Dziękujemy za płatność!",
    "paymentPaidSubtitle": "Płatność została potwierdzona, a zamówienie jest w trakcie realizacji.",
    "paymentPendingTitle": "Czekamy na potwierdzenie płatności",
    "paymentPendingSubtitle": "Zamówienie zostało zapisane. Czekamy na potwierdzenie płatności z Autopay.",
    "paymentFailedTitle": "Płatność nie powiodła się",
    "paymentFailedSubtitle": "Zamówienie zostało zapisane, ale płatność nie została potwierdzona. Sprawdź swoją skrzynkę e-mail, gdzie Autopay może wysłać więcej informacji.",
    "checkingOrderTitle": "Sprawdzamy zamówienie",
    "checkingOrderSubtitle": "Pobieramy aktualny status zamówienia i płatności.",
    "orderNotFoundTitle": "Nie znaleźliśmy zamówienia",
    "orderNotFoundSubtitle": "Nie możemy potwierdzić tego zamówienia. Sprawdź link albo wiadomość e-mail z potwierdzeniem.",
    "orderId": "ID zamówienia:",
    "goHome": "Przejd\u017a do strony głównej",
    "trackTitle": "Śledź swoje zamówienie",
    "trackText": "Aktualny status zamówienia sprawdzisz w każdej chwili. Link wysłaliśmy również na Twój adres e-mail.",
    "trackButton": "Sprawdź status zamówienia",
    "facebookTitle": "Bądź z nami na bieżąco",
    "facebookText": "Obserwuj nasz profil na Facebooku i nie przegap żadnych aktualności.",
    "facebookButton": "Odwiedź nasz Facebook"
  },

  "orderStatus": {
    "title": "Status zamówienia",
    "subtitle": "Sprawdź aktualny status swojego zamówienia.",
    "lookupLabel": "Numer zamówienia",
    "lookupPlaceholder": "Wpisz numer zamówienia",
    "lookupButton": "Sprawdź",
    "loading": "Pobieranie statusu zamówienia...",
    "emptyPrompt": "Wpisz numer zamówienia, aby sprawdzić jego status.",
    "notFound": "Nie znaleźliśmy zamówienia o podanym numerze.",
    "error": "Nie udało się pobrać statusu zamówienia. Spróbuj ponownie później.",
    "orderId": "Numer zamówienia",
    "orderedOn": "Data zamówienia",
    "preferredDate": "Preferowany termin",
    "items": "Zamówione produkty",
    "quantityUnit": "kg",
    "backHome": "Wróć na stronę główną",
    "steps": {
      "Pending": "Przyjęte",
      "Processing": "W realizacji",
      "Shipped": "W drodze",
      "Delivered": "Dostarczone"
    },
    "stepDescriptions": {
      "Pending": "Zamówienie zostało przyjęte i czeka na potwierdzenie.",
      "Processing": "Kompletujemy Twoje zamówienie.",
      "Shipped": "Zamówienie jest w drodze do Ciebie.",
      "Delivered": "Zamówienie zostało dostarczone."
    },
    "pickupSteps": {
      "Shipped": "Gotowe do odbioru",
      "Delivered": "Odebrane"
    },
    "pickupStepDescriptions": {
      "Shipped": "Twoje zamówienie jest gotowe do odbioru.",
      "Delivered": "Zamówienie zostało odebrane."
    },
    "statusLabels": {
      "Pending": "Przyjęte",
      "Processing": "W realizacji",
      "Shipped": "W drodze",
      "Delivered": "Dostarczone",
      "Cancelled": "Anulowane",
      "Returned": "Zwrócone"
    },
    "cancelledText": "To zamówienie zostało anulowane. W razie pytań prosimy o kontakt.",
    "returnedText": "To zamówienie zostało zwrócone. W razie pytań prosimy o kontakt."
  },

  "notFoundView": {
    "title": "Nie znaleziono strony",
    "subtitle": "Strona, której szukasz, nie istnieje albo została przeniesiona.",
    "goHome": "Wróć na stronę główną"
  },

  "orderView": {
    "title": "Złóż zamówienie",
    "subtitle": "Uzupełnij formularz i zamów pyszną borówkę.",
    "next": "Dalej",
    "recaptchaFailed": "Weryfikacja reCAPTCHA nie powiodła się.",
    "formSuccess": "Twoje zamówienie zostało złożone pomyślnie!",
    "formErrors": "Formularz zawiera błędy",
    "formErrorsDesc": "Uzupełnij poprawnie wszystkie wymagane pola.",
    "blikCodeMissing": "Wpisz kod BLIK, aby opłacić zamówienie.",
    "blikPaymentRejected": "Płatność BLIK nie została potwierdzona",
    "blikPaymentRejectedDesc": "Sprawdź kod w aplikacji bankowej i spróbuj ponownie.",
    "previousBlikPaymentSucceeded": "Poprzednia próba płatności BLIK się powiodła",
    "previousBlikPaymentSucceededDesc": "Nie uruchomiliśmy nowej płatności."
  },

  "seasonGate": {
    "before_start": {
      "title": "Sezon borówkowy jeszcze się nie rozpoczął",
      "description": "Borówki jeszcze dojrzewają, sezon borówkowy rozpocznie się wkrótce.",
      "facebookCta": "Jeżeli chcesz śledzić aktualne informacje, zapraszamy Cię na naszego facebooka {facebook}"
    },
    "after_end": {
      "title": "Sezon borówkowy dobiegł końca",
      "description": "Dziękujemy za tegoroczny sezon. Zamówienia będą ponownie dostępne w kolejnym sezonie."
    }
  },

  "checkoutView": {
    "title": "Podsumowanie zamówienia",
    "subtitle": "Sprawd\u017a poprawność swoich danych.",
    "blueberry": "Borówka",
    "back": "Wstecz",
    "submitting": "Składanie zamówienia...",
    "redirecting": "Przekierowanie do płatności...",
    "processingPayment": "Przetwarzanie płatności...",
    "submit": "Złóż zamówienie",
    "payOnline": "Zapłać",
    "pay": "Zapłać",
    "blikDialogTitle": "Wpisz kod BLIK",
    "blikDialogDescription": "Wygeneruj kod w aplikacji bankowej i wpisz go poniżej.",
    "blikConfirmTitle": "Potwierdź płatność w banku",
    "blikConfirmDescription": "Sprawdź aplikację bankową i zaakceptuj płatność BLIK.",
    "cancelBlikTitle": "Przerwać płatność BLIK?",
    "cancelBlikDescription": "Zamkniemy oczekiwanie na potwierdzenie. Możesz wpisać nowy kod BLIK i spróbować ponownie.",
    "cancelBlikContinue": "Kontynuuj oczekiwanie",
    "cancelBlikConfirm": "Przerwij",
    "blikCodeLabel": "Kod BLIK",
    "blikCodeHelp": "Wpisz 6-cyfrowy kod z aplikacji bankowej.",
    "blikCodeRequired": "Wpisz poprawny 6-cyfrowy kod BLIK."
  },

  "termsCheckbox": {
    "accept": "Akceptuję regulamin",
    "andPrivacy": "oraz politykę prywatności sklepu.",
    "required": "(wymagane)",
    "mustAccept": "Musisz zaakceptować regulamin."
  },

  "termsView": {
    "title": "Regulamin Sklepu",
    "subtitle": "Regulamin Sklepu Internetowego Gospodarstwa Rolnego Mateusz Wdowiak.",
    "download": "Pobierz regulamin (.docx)"
  },

  "privacyView": {
    "title": "Polityka Prywatności",
    "subtitle": "Zasady przetwarzania danych osobowych w Sklepie Internetowym borowkaszczecin.pl.",
    "download": "Pobierz politykę prywatności (.docx)"
  },

  "deliveryView": {
    "title": "Informacje o dostawach",
    "subtitle": "Dostarczamy zamówienia wyłącznie na terenie zaznaczonym na mapie.",
    "infoText": "Jeśli nie masz pewności, czy Twoja lokalizacja znajduje się w naszej strefie dostaw, skontaktuj się z nami przed złożeniem zamówienia.",
    "contactText": "W razie wątpliwości skontaktuj się z nami pod numerem xxx lub przez media społecznościowe.",
    "mapTitle": "Mapa obszaru dostawy",
    "locationsTitle": "Obsługiwane lokalizacje",
    "locationsDescription": "Poniżej znajdziesz listę lokalizacji objętych dostawą. Liczba lokalizacji: {count}.",
    "searchPlaceholder": "Wyszukaj lokalizację...",
    "noResults": "Nie znaleziono pasującej lokalizacji."
  },
  "order": {
    "create": "Utwórz nowe zamówienie",
    "createDescription": "Utwórz zamówienie. Kliknij \u201eZapisz\u201d, gdy skończysz.",
    "typeDelivery": "Dostawa",
    "typePickup": "Odbiór osobisty",
    "cardTitles": {
      "personalData": "Dane osobowe",
      "deliveryAddress": "Adres dostawy",
      "driver": "Kierowca",
      "deliveryTime": "Termin dostawy",
      "pickupTime": "Termin odbioru",
      "product": "Produkt",
      "payment": "Metoda płatności",
      "paymentStatus": "Status płatności",
      "status": "Status zamówienia",
      "note": "Uwagi do zamówienia",
      "details": "Szczegóły zamówienia"
    },
    "calendar": {
      "prevMonth": "Poprzedni miesiąc",
      "nextMonth": "Następny miesiąc"
    },
    "formLabels": {
      "firstName": "Imię",
      "lastName": "Nazwisko",
      "phoneNumber": "Numer telefonu",
      "email": "Adres e-mail",
      "localization": "Rodzaj lokacji",
      "localizationPlaceholder": "Wybierz rodzaj lokacji",
      "street": "Ulica",
      "buildingNumber": "Numer budynku",
      "apartmentNumber": "Numer mieszkania",
      "postalCode": "Kod pocztowy",
      "city": "Miasto",
      "district": "Dzielnica",
      "driverAddressNote": "Notatka kierowcy przypisana do adresu",
      "driverAddressNotePlaceholder": "Wpisz informację przydatną przy dostawie",
      "asFastAsPossible": "Najszybciej jak to możliwe",
      "or": "lub",
      "preferredTime": "Preferowany czas dostawy:",
      "deliveryDate": "Data dostawy:",
      "pickupTime": "Godzina odbioru:",
      "pickupDate": "Data odbioru: ",
      "chooseDate": "Wybierz datę",
      "today": "Dziś",
      "hour": "Godzina",
      "minute": "Minuta",
      "product": "Produkt",
      "quantity": "Ilość",
      "card": "BLIK",
      "autopay": "Autopay",
      "cash": "Gotówka",
      "paymentStatus": "Status płatności",
      "status": "Status zamówienia",
      "notePlaceholder": "Kod do bramy, piętro, uwaga na psa",
      "priceUnit": "zł / szt.",
      "currencyUnit": "zł",
      "subtotal": "Suma częściowa",
      "delivery": "Dostawa",
      "tax": "Podatek",
      "total": "Suma"
    },
    "checkout": {
      "pickupTime": "Data odbioru",
      "deliveryTime": "Preferowany czas dostawy",
      "contactData": "Dane kontaktowe",
      "customerData": "Imię i nazwisko"
    },
    "similarOrders": {
      "title": "Podobne zamówienia",
      "description": "Wybierz pozycję, aby uzupełnić dane klienta i adres.",
      "startTyping": "Zacznij wpisywać dane klienta lub adresu, aby wyszukać podobne zamówienia.",
      "searching": "Wyszukiwanie...",
      "empty": "Brak podobnych zamówień dla obecnych danych.",
      "select": "Wybierz",
      "noDeliveryAddress": "Brak adresu dostawy",
      "lastOrder": "Ostatnie zamówienie: {date}"
    },
    "info": {
      "deliveryInfo": "Informacje o dostawach",
      "deliverySameDay": "Jeśli zamówienie zostanie złożone rano i wybierzesz opcję \u201enajszybciej jak to możliwe\u201d, istnieje możliwość realizacji dostawy jeszcze tego samego dnia.",
      "deliveryRainInfo": "Należy jednak pamiętać, że w przypadku intensywnych opadów deszczu może wystąpić opó\u017anienie. W takiej sytuacji poinformujemy Cię o zmianie terminu dostawy.",
      "pickupInfo": "Informacje o odbiorze osobistym",
      "pickupHours": "Odbiór osobisty możliwy jest w godzinach 10:00\u201318:00.",
      "deliveryTimeInfo": "Informacje o terminie dostawy",
      "deliveryTimeDetails": "Dostawy pod adresy domowe odbywają się zwykle w godzinach 17:00\u201322:00. Staramy się dostarczyć owoce tak szybko, jak to możliwe. Dostarczane borówki pochodzą ze zbioru z danego dnia, dlatego jesteśmy uzależnieni od ilości zebranych owoców oraz warunków pogodowych, takich jak opady deszczu, które mogą uniemożliwić zbiór. W związku z tym prosimy brać pod uwagę, że termin dostawy może ulec zmianie.",
      "paymentInfo": "Informacje o płatności",
      "cashOnly": "Płatności online obsługuje Autopay. Możesz wybrać BLIK, Autopay albo gotówkę przy odbiorze.",
      "morePaymentsSoon": "Po wyborze BLIK wpiszesz kod z aplikacji bankowej w podsumowaniu zamówienia.",
      "sorryForInconvenience": "Przepraszamy za niedogodności i dziękujemy za wyrozumiałość.",
      "deliveryArea": "Dostawy realizujemy wyłącznie na terenie Szczecina i Polic.",
      "deliveryAreaDetails": "Szczegółową listę obsługiwanych lokalizacji znajdziesz",
      "here": "tutaj"
    },
    "api": {
      "errorMessage": "Wystąpił błąd podczas składania zamówienia. Spróbuj ponownie później.",
      "createSuccess": "Twoje zamówienie zostało pomyślnie złożone!",
      "updateSuccess": "Zamówienie zostało zaktualizowane pomyślnie!",
      "deleteSuccess": "Zamówienie zostało usunięte!"
    }
  },
  "driver": {
    "cardTitles": {
      "driver": "Kierowca",
      "user": "Użytkownik",
      "endingAddress": "Adres końcowy"
    },
    "formLabels": {
      "capacity": "Pojemność (kg)",
      "maxOrderCount": "Maksymalna liczba zamówień",
      "color": "Kolor",
      "colorPicker": "Wybierz kolor",
      "accountMode": "Sposób przypisania konta",
      "account": "Istniejące konto",
      "email": "E-mail",
      "password": "Hasło",
      "street": "Ulica",
      "buildingNumber": "Numer budynku",
      "apartmentNumber": "Numer mieszkania",
      "postalCode": "Kod pocztowy",
      "city": "Miasto",
      "streetName": "Nazwa ulicy"
    },
    "formHints": {
      "accountPlaceholder": "Wybierz konto po adresie e-mail",
      "accountsLoading": "Ładowanie kont...",
      "noAccounts": "Brak dostępnych kont"
    },
    "accountModes": {
      "existing": "Wybierz istniejące konto",
      "create": "Utwórz nowe konto"
    },
    "api": {
      "createSuccess": "Kierowca został utworzony pomyślnie!",
      "updateSuccess": "Kierowca został zaktualizowany pomyślnie!",
      "deleteSuccess": "Kierowca został usunięty!"
    }
  },
  "route": {
    "api": {
      "createSuccess": "Trasa została utworzona pomyślnie!"
    }
  },
  "routePoints": {
    "api": {
      "updateSuccess": "Punkt trasy został zaktualizowany pomyślnie!"
    }
  },
  "district": {
    "api": {
      "createSuccess": "Dzielnice zostały utworzone pomyślnie!",
      "updateSuccess": "Dzielnice zostały zaktualizowane pomyślnie!"
    }
  },
  "blueberry": {
    "updateSuccess": "Cena została zaktualizowana!",
    "updateError": "Wystąpił błąd podczas aktualizacji ceny."
  },
  "admin": {
    "common": {
      "yes": "Tak",
      "no": "Nie",
      "unknown": "Nieznany"
    },
    "nav": {
      "dashboard": "Panel",
      "login": "Logowanie",
      "home": "Strona główna",
      "orders": "Zamówienia",
      "routes": "Trasy",
      "drivers": "Kierowcy",
      "analytics": "Analityka",
      "history": "Historia",
      "settings": "Ustawienia"
    },
    "topbar": {
      "toggleMenu": "Przełącz menu",
      "toggleUserMenu": "Przełącz menu użytkownika",
      "searchPlaceholder": "Szukaj zamówień...",
      "searchingOrders": "Wyszukiwanie zamówień...",
      "noOrdersFound": "Nie znaleziono zamówień",
      "searchError": "Nie udało się wyszukać zamówień",
      "showingFirstOrders": "Wyświetlono pierwsze {count} z {total} zamówień",
      "myAccount": "Moje konto",
      "settings": "Ustawienia",
      "logout": "Wyloguj"
    },
    "table": {
      "refreshAndClearFilters": "Odśwież i wyczyść filtry",
      "import": "Import",
      "export": "Eksport",
      "importSuccess": "Import zakończył się powodzeniem.",
      "importError": "Import nie powiódł się.",
      "exportSuccess": "Eksport zakończył się powodzeniem.",
      "exportError": "Eksport nie powiódł się.",
      "searchAllColumns": "Szukaj we wszystkich kolumnach...",
      "noResults": "Brak wyników",
      "selectAll": "Zaznacz wszystkie",
      "selectRow": "Zaznacz wiersz",
      "filterByDate": "Filtruj wg daty",
      "filterByType": "Filtruj wg typu",
      "allTypes": "Wszystkie typy",
      "typeDelivery": "Dostawa",
      "typePickup": "Odbiór",
      "filterByStatus": "Filtruj wg statusu",
      "filterByPaymentStatus": "Filtruj wg statusu płatności",
      "filterByDriver": "Filtruj wg kierowcy",
      "allDrivers": "Wszyscy kierowcy",
      "filterByConfidence": "Filtruj wg pewności",
      "allConfidenceLevels": "Wszystkie poziomy pewności",
      "lowConfidence": "Niska pewność",
      "filterByLocationType": "Filtruj wg typu adresu",
      "allLocationTypes": "Wszystkie typy adresów",
      "officeOrders": "Do biura",
      "apartmentAddresses": "Mieszkanie",
      "houseAddresses": "Dom",
      "otherAddresses": "Inne",
      "filterByComment": "Filtruj wg opisu",
      "allComments": "Wszystkie opisy",
      "withComment": "Z opisem",
      "withoutComment": "Bez opisu",
      "allStatuses": "Wszystkie statusy",
      "statusOr": "lub",
      "allPaymentStatuses": "Wszystkie statusy płatności",
      "statusPending": "Oczekujące",
      "statusProcessing": "W realizacji",
      "statusShipped": "Wysłane",
      "statusDelivered": "Dostarczone",
      "statusCancelled": "Anulowane",
      "statusReturned": "Zwrócone"
    },
    "pagination": {
      "showingRows": "Wyświetlono {count} {label}.",
      "row": "wiersz",
      "rows": "wiersze",
      "rowsPerPage": "Wierszy na stronę",
      "pageOf": "Strona {page} z {total}",
      "goFirst": "Przejdź do pierwszej strony",
      "goPrevious": "Przejdź do poprzedniej strony",
      "goNext": "Przejdź do następnej strony",
      "goLast": "Przejdź do ostatniej strony"
    },
    "home": {
      "allOrders": "Wszystkie zamówienia",
      "ordersFrom": "Zamówienia z BorowkaSzczecin."
    },
    "analytics": {
      "window": "Zakres",
      "today": "Dzisiaj",
      "last7d": "Ostatnie 7 dni",
      "last30d": "Ostatnie 30 dni",
      "custom": "Niestandardowy",
      "start": "Od",
      "end": "Do",
      "refreshKpis": "Odśwież KPI",
      "apiHealthSectionTitle": "Stan API",
      "apiHealthSectionSubtitle": "Błędy serwera i ograniczanie żądań w wybranym zakresie.",
      "googleSectionTitle": "Wyniki Google",
      "googleSectionSubtitle": "Wyniki wyszukiwania i ruch na stronie w wybranym zakresie.",
      "googleUnavailable": "Niektóre dane Google są niedostępne. Sprawdź dane logowania integracji i uprawnienia do usług.",
      "cards": {
        "ordersTitle": "Zamówienia",
        "ordersSubtitle": "Suma w wybranym zakresie",
        "pendingTitle": "Zamówienia oczekujące",
        "pendingSubtitle": "Oczekują na realizację",
        "deliveredTitle": "Zamówienia dostarczone",
        "deliveredSubtitle": "Zrealizowane dostawy",
        "revenueTitle": "Przychód",
        "revenueSubtitle": "Zamówienia oraz dodatkowa sprzedaż na trasach",
        "soldKgTitle": "Sprzedano",
        "soldKgSubtitle": "Zamówienia bez anulowanych i zwrotów oraz dodatkowa sprzedaż na trasach",
        "extraSoldKgTitle": "Dodatkowo sprzedano",
        "extraSoldKgSubtitle": "Dodatkowe borówki sprzedane przez kierowców na trasach",
        "mixTitle": "Struktura typów zamówień",
        "mixSubtitle": "Dostawa / Odbiór",
        "averageTitle": "Średnia wartość zamówienia",
        "averageSubtitle": "Na zamówienie w wybranym zakresie",
        "abandonedFormsTitle": "Porzucone formularze",
        "abandonedFormsSubtitle": "Brak aktywności lub zamówienia przez co najmniej {minutes} minut",
        "apiErrorsTitle": "Współczynnik błędów API",
        "apiErrorsSubtitle": "Odpowiedzi HTTP 5xx (liczba i współczynnik)",
        "throttledRequestsTitle": "Ograniczone żądania",
        "throttledRequestsSubtitle": "Odpowiedzi HTTP 429 w wybranym zakresie",
        "searchClicksTitle": "Kliknięcia z wyszukiwarki Google",
        "searchImpressionsTitle": "Wyświetlenia w wyszukiwarce Google",
        "searchCtrTitle": "CTR wyszukiwarki",
        "searchPositionTitle": "Średnia pozycja w wyszukiwarce",
        "searchConsoleSubtitle": "Google Search Console",
        "activeUsersTitle": "Aktywni użytkownicy strony",
        "sessionsTitle": "Sesje w witrynie",
        "googleAnalyticsSubtitle": "Google Analytics (ruch po wyrażeniu zgody)"
      }
    },
    "orders": {
      "deliveryOrders": "Zamówienia z dostawą",
      "deliverySubtitle": "Dzisiejsze zamówienia z dostawą z BorowkaSzczecin.",
      "deliverySubtitleForDate": "Zamówienia z dostawą w realizacji na dzień {date}.",
      "pickupOrders": "Zamówienia z odbiorem",
      "pickupSubtitle": "Dzisiejsze zamówienia z odbiorem z BorowkaSzczecin.",
      "accept": "Akceptuj",
      "cancel": "Anuluj",
      "selectedCount": "Zaznaczono: {count}",
      "massAction": "Akcja masowa",
      "massActionTitle": "Akcja masowa dla zaznaczonych zamówień",
      "massActionDescription": "Wybierz status zamówienia, preferowany dzień, status płatności lub dowolną kombinację dla {count} zaznaczonych zamówień.",
      "orderStatus": "Status zamówienia",
      "paymentStatus": "Status płatności",
      "preferredDay": "Preferowany dzień",
      "setPreferredDay": "Ustaw preferowany dzień",
      "clearPreferredDay": "Wyczyść preferowany dzień",
      "leaveUnchanged": "Pozostaw bez zmian",
      "paymentStatusUnknown": "Nieznany",
      "paymentStatusUnpaid": "Nieopłacona",
      "paymentStatusAwaiting": "Oczekuje na płatność",
      "paymentStatusPaid": "Zapłacone",
      "paymentStatusFailed": "Nieudana",
      "applyMassAction": "Zastosuj zmiany",
      "massActionApplying": "Stosowanie...",
      "massUpdateSuccess": "Zaznaczone zamówienia zostały zaktualizowane",
      "massUpdateError": "Nie udało się zaktualizować wszystkich zaznaczonych zamówień",
      "statusUpdatedSuccess": "Status zamówienia został zmieniony",
      "statusUpdatedError": "Nie udało się zmienić statusu zamówienia",
      "routeUpdatedSuccess": "Trasa została zaktualizowana pomyślnie",
      "routeCreatedSuccess": "Trasa została utworzona pomyślnie",
      "routeCreateError": "Błąd podczas tworzenia trasy"
    },
    "quickOrder": {
      "button": "Szybkie zamówienie",
      "title": "Szybkie dodawanie zamówień",
      "quantity": "Ilość",
      "street": "Ulica",
      "streetSearchPlaceholder": "Szukaj blisko swojej lokalizacji",
      "buildingNumber": "Nr budynku",
      "apartmentNumber": "Nr mieszkania",
      "city": "Miasto",
      "district": "Dzielnica",
      "phone": "Nr telefonu",
      "assignedDriver": "Kierowca",
      "clearAssignedDriver": "Wyczyść przypisanego kierowcę",
      "blik": "BLIK",
      "blikPaid": "Oznacz jako zapłacone przez BLIK",
      "note": "Opis",
      "action": "Akcja",
      "add": "Dodaj",
      "adding": "Dodawanie...",
      "clear": "Wyczyść",
      "keyboardHint": "Użyj Tab, aby przechodzić między polami, i Enter, aby dodać zamówienie.",
      "createSuccess": "Dodano zamówienie. Możesz wpisać następne.",
      "createError": "Nie udało się dodać szybkiego zamówienia.",
      "mapTitle": "Mapa zamówień",
      "mapDrivers": "Kierowcy:",
      "mapStatuses": "Status:",
      "unassignedDriver": "Brak kierowcy",
      "mapEmpty": "Brak zamówień z pozycją na mapie dla tego dnia.",
      "mapLoadError": "Nie udało się wczytać mapy zamówień.",
      "mapMissingGeolocation": "{count} zamówienie nie ma pozycji na mapie. | {count} zamówienia nie mają pozycji na mapie. | {count} zamówień nie ma pozycji na mapie.",
      "enteredAddress": "Wprowadzany adres",
      "usePin": "Użyj pinezki"
    },
    "orderDetails": {
      "title": "Szczegóły zamówienia",
      "orderId": "ID zamówienia",
      "copyOrderId": "Kopiuj ID zamówienia",
      "date": "Data",
      "delivery": "Dostawa",
      "pickup": "Odbiór",
      "sectionOrderDetails": "Szczegóły zamówienia",
      "subtotal": "Suma częściowa",
      "shipping": "Dostawa",
      "tax": "Podatek",
      "total": "Razem",
      "shippingInfo": "Informacje o dostawie",
      "driver": "Kierowca",
      "pickupTime": "Godzina odbioru",
      "preferredDeliveryTime": "Preferowany czas dostawy",
      "comment": "Opis",
      "customerInfo": "Informacje o kliencie",
      "customer": "Klient",
      "email": "E-mail",
      "phone": "Telefon",
      "openInGoogleMaps": "Otwórz w Mapach Google",
      "editGeolocation": "Edytuj pozycję na mapie",
      "editGeolocationHint": "Kliknij przycisk mapy, aby poprawić pozycję.",
      "missingGeolocationWarningTitle": "Brak pozycji na mapie",
      "missingGeolocationWarningDescription": "Kliknij, aby wyszukać adres lub ustawić pinezkę ręcznie.",
      "geolocationEditorTitle": "Edytuj pozycję na mapie",
      "geolocationEditorDescription": "Wyszukaj adres i wybierz podpowiedź albo kliknij mapę Leaflet, aby ustawić pinezkę. Przed zapisaniem możesz również przeciągnąć pinezkę.",
      "storedAddress": "Adres zamówienia",
      "addressSearchLabel": "Wyszukaj adres",
      "addressSearchPlaceholder": "Ulica, nr budynku, kod pocztowy, miasto",
      "searchAddress": "Szukaj",
      "searchingAddress": "Wyszukiwanie...",
      "noAddressSearchResults": "Nie znaleziono pasujących adresów.",
      "addressSearchError": "Wyszukiwanie adresu jest obecnie niedostępne.",
      "mapPosition": "Pozycja pinezki",
      "addressMapPreviewEmpty": "Wyszukaj i wybierz adres, aby zobaczyć punkt na mapie.",
      "mapPositionHint": "Kliknij mapę lub przeciągnij pinezkę, aby dokładnie poprawić pozycję.",
      "selectedCoordinates": "Wybrane współrzędne",
      "latitude": "Szerokość geograficzna",
      "longitude": "Długość geograficzna",
      "cancelGeolocationEdit": "Anuluj",
      "saveGeolocation": "Zapisz pozycję",
      "savingGeolocation": "Zapisywanie...",
      "geolocationSaved": "Zapisano pozycję na mapie.",
      "geolocationSaveError": "Nie udało się zapisać pozycji na mapie.",
      "geocodingWarningTitle": "Sprawdź pinezkę na mapie",
      "geocodingWarningDescription": "Geoapify nie dopasowało całego adresu lub jeden ze współczynników pewności jest niższy niż {threshold}.",
      "geocodingConfidenceOverall": "Ogólna pewność",
      "geocodingConfidenceCity": "Pewność miasta",
      "geocodingConfidenceStreet": "Pewność ulicy",
      "geocodingConfidenceBuilding": "Pewność budynku",
      "geocodingMatchType": "Sposób dopasowania",
      "geocodingResultType": "Poziom dopasowania",
      "geocodingMatchTypes": {
        "fullMatch": "Pełne dopasowanie",
        "innerPart": "Wewnętrzna część adresu",
        "byBuilding": "Dopasowanie po budynku",
        "byStreet": "Dopasowanie po ulicy",
        "byPostcode": "Dopasowanie po kodzie pocztowym",
        "byCityOrDistrict": "Dopasowanie po mieście lub dzielnicy",
        "byCountryOrState": "Dopasowanie po kraju lub województwie"
      },
      "geocodingResultTypes": {
        "building": "Budynek",
        "street": "Ulica",
        "postcode": "Kod pocztowy",
        "district": "Dzielnica",
        "city": "Miasto",
        "county": "Powiat",
        "state": "Województwo",
        "country": "Kraj"
      },
      "paymentInfo": "Informacje o płatności",
      "status": "Status",
      "method": "Metoda",
      "updated": "Zaktualizowano"
    },
    "orderCards": {
      "createTitle": "Utwórz zamówienie",
      "createDescription": "Utwórz zamówienie ręcznie",
      "createButton": "Utwórz zamówienie",
      "driversTitle": "Kierowcy",
      "driversDescription": "Wybierz kierowców, ustaw dzień i sprawdź gotowość trasy.",
      "driversLabel": "Kierowcy",
      "routeDateLabel": "Dzień trasy",
      "selectDriver": "Wybierz kierowcę",
      "noDriverFound": "Nie znaleziono kierowcy.",
      "showRoute": "Pokaż trasę",
      "createRoute": "Stwórz trasę",
      "previewRoute": "Podgląd trasy",
      "previewRouteLoading": "Ładowanie podglądu...",
      "deliveryWeightTitle": "Waga dostaw",
      "deliveryWeightDescription": "Łączna waga zamówień z dostawą w realizacji na dzień {date}.",
      "pickupWeightTitle": "Waga odbiorów",
      "pickupWeightDescription": "Łączna waga zamówień z odbiorem w realizacji na dzień {date}.",
      "filteredWeightTitle": "Waga zamówień",
      "filteredWeightDescription": "Łączna waga zamówień zgodnych z filtrami tabeli.",
      "orderCount": "{count} zamówienie | {count} zamówienia | {count} zamówień",
      "dailyWeightSelectDate": "Wybierz dzień, aby zobaczyć wagę zamówień w realizacji.",
      "dailyWeightLoading": "Obliczanie wagi zamówień...",
      "dailyWeightError": "Nie udało się pobrać wagi zamówień.",
      "categorySummaryTitle": "Podsumowanie zamówień",
      "categorySummaryPendingDescription": "Oczekujące zamówienia według kategorii.",
      "categorySummaryProcessingDescription": "Zamówienia w realizacji według kategorii.",
      "categorySummaryLoading": "Ładowanie podsumowania zamówień...",
      "categorySummaryError": "Nie udało się pobrać podsumowania zamówień.",
      "officeOrders": "Do biura",
      "ordersWithComment": "Z opisem",
      "pickupOrders": "Z odbiorem",
      "unsettledRoutesTitle": "Nierozliczone trasy",
      "unsettledRoutesDescription": "Trasy z pominiętymi punktami, które nadal wymagają rozliczenia.",
      "unsettledRoutesLoading": "Ładowanie nierozliczonych tras...",
      "unsettledRoutesError": "Nie udało się pobrać liczby nierozliczonych tras.",
      "routeCount": "trasa | trasy | tras",
      "settleRoutes": "Rozlicz",
      "blueberryPriceTitle": "Cena borówki",
      "blueberryPriceDescription": "Zaktualizuj bieżącą cenę borówki",
      "currentPrice": "Aktualna cena",
      "updatePrice": "Zaktualizuj cenę"
    },
    "drivers": {
      "createTitle": "Utwórz kierowcę",
      "createDescription": "Utwórz nowego kierowcę",
      "createButton": "Utwórz kierowcę",
      "tableTitle": "Kierowcy",
      "tableSubtitle": "Twoja flota kierowców",
      "selectDriver": "Wybierz kierowcę",
      "driversLabel": "Kierowcy",
      "saveDistricts": "Zapisz",
      "districtsSaveSuccess": "Dzielnice zapisano pomyślnie",
      "districtsSaveError": "Błąd podczas zapisywania dzielnic",
      "detailsTitle": "Szczegóły kierowcy",
      "detailsDescription": "Szczegółowe informacje o kierowcy.",
      "driverId": "ID kierowcy",
      "copyDriverId": "Kopiuj ID kierowcy",
      "endingAddress": "Adres końcowy",
      "driverInfo": "Informacje o kierowcy",
      "name": "Imię i nazwisko",
      "email": "E-mail",
      "phone": "Telefon",
      "capacity": "Pojemność",
      "maxOrderCount": "Maksymalna liczba zamówień",
      "unlimited": "Bez limitu",
      "userInfo": "Informacje o użytkowniku",
      "districts": "Dzielnice",
      "dateJoined": "Data dołączenia",
      "dialog": {
        "updateTitle": "Aktualizuj kierowcę",
        "createTitle": "Utwórz nowego kierowcę",
        "updateDescription": "Zaktualizuj kierowcę. Kliknij aktualizuj po zakończeniu.",
        "createDescription": "Utwórz kierowcę. Kliknij zapisz po zakończeniu.",
        "updateButton": "Aktualizuj",
        "saveButton": "Zapisz"
      }
    },
    "routes": {
      "title": "Trasy",
      "subtitle": "Twoje trasy",
      "previewTitle": "Podgląd trasy",
      "eligibleOrders": "Zamówienia gotowe",
      "missingGeolocation": "Brak geolokalizacji",
      "optimizationRules": "Reguły optymalizacji",
      "enforceCapacity": "Uwzględniaj pojemność",
      "enforceCapacityHint": "Przestrzegaj limitu wagi pojazdu.",
      "enforceOrderCount": "Uwzględniaj liczbę zamówień",
      "enforceOrderCountHint": "Przestrzegaj maksymalnej liczby zamówień kierowcy.",
      "enforceDistrictSkills": "Uwzględniaj dzielnice",
      "enforceDistrictSkillsHint": "Zamówienia bez ręcznie ustawionego kierowcy przypisuj tylko kierowcom obsługującym daną dzielnicę.",
      "enforceAssignedDriver": "Wymuszaj kierowcę z zamówienia",
      "enforceAssignedDriverHint": "Nie przenoś zamówienia do innego kierowcy niż wskazany w polu Kierowca.",
      "preserveDriverAssignments": "Zachowaj bieżące przypisania",
      "preserveDriverAssignmentsHint": "Pozostaw zamówienia u obecnych kierowców i zmień tylko kolejność przystanków.",
      "proposedRoutesMapEmpty": "Brak proponowanych punktów trasy do pokazania na mapie.",
      "dropOrdersHere": "Upuść tutaj zamówienia",
      "unassignedOrders": "Nieprzypisane zamówienia",
      "capacityViolations": "Naruszenia pojemności",
      "excludedOrders": "Wykluczone zamówienia",
      "emptySection": "Brak pozycji do wyświetlenia.",
      "remainingCapacity": "{value} kg wolne",
      "overCapacity": "{value} kg ponad limit",
      "routeOrderCount": "{count} / {max} zamówień",
      "routeOrderCountUnlimited": "{count} zamówień / bez limitu",
      "latitude": "Szerokość",
      "longitude": "Długość",
      "latitudePlaceholder": "53.4285",
      "longitudePlaceholder": "14.5528",
      "saveCoordinates": "Zapisz współrzędne",
      "savingCoordinates": "Zapisywanie...",
      "coordinatesSavedSuccess": "Współrzędne zapisano pomyślnie",
      "coordinatesSavedError": "Nie udało się zapisać współrzędnych",
      "createRoutes": "Utwórz trasy",
      "creatingRoutes": "Tworzenie tras...",
      "reoptimizeRoutes": "Optymalizuj ponownie",
      "reoptimizingRoutes": "Ponowna optymalizacja...",
      "reoptimizeRoutesError": "Nie udało się ponownie zoptymalizować tras",
      "addOrder": "Dodaj zamówienie do trasy",
      "addOrderSuccess": "Zamówienie dodano, a pozostałą część trasy zoptymalizowano ponownie",
      "addOrderError": "Nie udało się dodać zamówienia do trasy",
      "reportAction": "Raport",
      "reportTitle": "Raport zakończonej trasy",
      "reportDescription": "Kierowca: {driver} · Data: {date}",
      "reportTakenKg": "Zabrano na trasę",
      "reportOrderSoldKg": "Sprzedano z zamówień",
      "reportExtraSoldKg": "Sprzedano dodatkowo",
      "reportTotalSoldKg": "Sprzedano łącznie",
      "reportRevenue": "Przychód",
      "reportDuration": "Czas trasy",
      "reportTimeline": "Przebieg trasy",
      "reportTimelineDescription": "Punkty są ułożone według faktycznego czasu odwiedzin.",
      "reportPoint": "Punkt",
      "reportPointNumber": "Punkt {number}",
      "reportAddress": "Adres",
      "reportVisitedAt": "Odwiedzono",
      "reportTimeFromPrevious": "Od poprzedniego punktu",
      "reportRouteStart": "Start trasy",
      "reportNoVisitedPoints": "Brak odwiedzonych punktów do pokazania.",
      "createRoutesSuccess": "Trasy utworzono pomyślnie",
      "createRoutesError": "Nie udało się utworzyć tras",
      "previewError": "Nie udało się wczytać podglądu trasy",
      "unroutableOrdersTitle": "Silnik tras nie może wyznaczyć drogi do tych adresów",
      "unroutableOrdersDescription": "Popraw lokalizację adresu albo usuń zamówienie, a następnie spróbuj ponownie utworzyć trasę.",
      "unroutableOrdersTableTitle": "Zamówienia z niedostępnymi adresami",
      "unroutableOrdersLoadError": "Nie udało się wczytać zamówień z niedostępnymi adresami",
      "clearDraft": "Wyczyść trasy",
      "clearingDraft": "Czyszczenie tras...",
      "draftSaveError": "Nie udało się zapisać podglądu tras",
      "draftLoadError": "Nie udało się odtworzyć podglądu tras",
      "draftClearSuccess": "Wyczyszczono zapisany podgląd tras",
      "draftClearError": "Nie udało się wyczyścić podglądu tras",
      "reasonWrongDate": "Wykluczono, bo preferowana data się nie zgadza",
      "reasonMissingAddress": "Wykluczono, bo zamówienie nie ma adresu",
      "unassignedCapacityOrConstraints": "Optymalizator nie mógł przypisać tego zamówienia.",
      "unassignedOrderTooHeavy": "To zamówienie jest cięższe niż pojemność każdego wybranego kierowcy.",
      "unassignedDriverNotSelected": "Kierowca przypisany do tego zamówienia nie został wybrany do planowania trasy.",
      "violationTotalCapacityExceeded": "Łączne zapotrzebowanie trasy przekracza pojemność wybranych kierowców.",
      "violationRouteCapacityExceeded": "Proponowany ładunek przekracza pojemność kierowcy {driver}.",
      "violationOrderTooHeavy": "Zamówienie #{orderId} przekracza największą pojemność wybranego kierowcy.",
      "capacityViolationSummary": "Ładunek: {load} kg, pojemność: {capacity} kg, nadmiar: {overflow} kg.",
      "detailsTitle": "Trasa",
      "copyDriverLink": "Kopiuj link dla kierowcy",
      "copyDriverLinkSuccess": "Link dla kierowcy został skopiowany",
    "copyDriverLinkError": "Nie udało się skopiować linku dla kierowcy",
    "driverPortalTitle": "Trasy kierowcy",
    "driverRoutesTitle": "Twoje trasy",
    "noAssignedRoutes": "Nie masz jeszcze przypisanych tras.",
      "routeDate": "Data trasy",
      "statusNotStarted": "Nierozpoczęta",
      "statusInProgress": "W trakcie",
      "statusCompleted": "Zakończona",
      "statusUnsettled": "Nierozliczona",
      "durationLessThanMinute": "poniżej 1 min",
      "durationMinutes": "{minutes} min",
      "durationHours": "{hours} godz.",
      "durationHoursMinutes": "{hours} godz. {minutes} min",
      "backToRoutes": "Wróć do tras",
    "driverRouteLoading": "Ładowanie trasy...",
      "driverRouteError": "Nie udało się wczytać trasy.",
      "routePoints": "Punkty trasy",
      "googleMapsRoutes": "Trasy w Mapach Google",
      "googleMapsRouteSegment": "Trasa {number}: {start}–{end}",
    "totalAmount": "Łączna ilość",
      "plannedLoad": "Zaplanowane na trasie",
      "loadedAmount": "Zabrano borówek",
      "loadedAmountInvalid": "Wpisz pełną liczbę kilogramów, nie mniejszą niż zaplanowano na trasie.",
      "loadedAmountSaveSuccess": "Zapisano ilość zabraną na trasę",
      "loadedAmountSaveError": "Nie udało się zapisać ilości zabranej na trasę",
      "extraSoldAmount": "Sprzedano dodatkowych borówek",
      "extraSoldAmountInvalid": "Wpisz pełną liczbę kilogramów, nie mniejszą niż 0.",
      "extraSoldAmountSaveSuccess": "Zapisano ilość dodatkowo sprzedanych borówek",
      "extraSoldAmountSaveError": "Nie udało się zapisać ilości dodatkowo sprzedanych borówek",
      "currentDriverLoad": "Aktualnie u kierowcy",
    "exportAmount": "Ilość",
    "descriptionPresent": "Tak",
    "descriptionAbsent": "Nie",
      "deliveryTime": "Czas dostarczenia",
      "orderPreviewTitle": "Podgląd zamówienia",
      "orderPreviewLoading": "Ładowanie szczegółów zamówienia...",
      "orderPreviewError": "Nie udało się wczytać szczegółów zamówienia.",
      "routeMap": "Mapa trasy",
      "routeMapLegend": "Legenda statusów punktów trasy",
      "routeMapPending": "Oczekujący",
      "routePointNext": "Następny",
      "routeMapVisited": "Odwiedzony",
      "routeMapSkipped": "Pominięty",
      "routeMapEmpty": "Brak punktów z poprawnymi współrzędnymi do pokazania na mapie.",
      "markVisited": "Odwiedzony",
      "markSkipped": "Pominięty",
      "editRouteOrder": "Edytuj kolejność",
      "editingRouteOrder": "Edytowanie kolejności przystanków",
      "movePointUp": "Przesuń punkt trasy w górę",
      "movePointDown": "Przesuń punkt trasy w dół",
      "reorderSuccess": "Zapisano kolejność punktów trasy",
      "reorderError": "Nie udało się zapisać kolejności punktów trasy",
      "visitedPaymentTitle": "Rozlicz płatność za dostawę",
      "visitedPaidCash": "Zapłacono gotówką",
      "visitedPaidBlik": "Zapłacono BLIKIEM",
      "navigate": "Nawiguj",
      "nextRoutePoint": "Następny punkt: {label}",
      "allRoutePointsCompleted": "Wszystkie punkty trasy są zakończone",
      "continueProgress": "Kontynuuj",
      "undoProgress": "Cofnij",
      "addressNote": "Notatka",
      "addressNoteTitle": "Notatki do adresu",
      "customerOrderComment": "Uwagi klienta z zamówienia",
      "noCustomerOrderComment": "Brak",
      "driverAddressNote": "Notatka kierowcy przypisana do adresu",
      "addressNotePlaceholder": "Wpisz informację przydatną przy dostawie",
      "addressNoteSaveSuccess": "Zapisano notatkę do adresu",
      "addressNoteSaveError": "Nie udało się zapisać notatki do adresu",
      "continueProgressSuccess": "Punkt oznaczono jako odwiedzony",
      "continueProgressError": "Nie udało się przejść do następnego punktu",
      "undoProgressSuccess": "Cofnięto ostatnią zmianę postępu",
      "undoProgressError": "Nie udało się cofnąć ostatniej zmiany",
      "call": "Zadzwoń",
      "markVisitedSuccess": "Punkt trasy oznaczono jako odwiedzony",
      "markVisitedError": "Nie udało się oznaczyć punktu jako odwiedzony",
      "markSkippedSuccess": "Punkt trasy oznaczono jako pominięty",
      "markSkippedError": "Nie udało się oznaczyć punktu jako pominięty",
      "finishRoundTitle": "Rozlicz trasę",
      "skippedOrderBadge": "Pominięty przystanek",
      "skippedOrderMeta": "Zamówienie #{orderId}",
      "resolveSkippedCancel": "Anuluj zamówienie",
      "resolveSkippedProcessing": "Przywróć do realizacji",
      "resolveSkipped": "Rozlicz pominięte zamówienia",
      "resolvingSkipped": "Rozliczanie pominiętych zamówień...",
      "resolveSkippedSuccess": "Pominięte zamówienia rozliczono pomyślnie",
      "resolveSkippedError": "Nie udało się rozliczyć pominiętych zamówień"
    },
    "history": {
      "title": "Historia audytu",
      "subtitle": "Trwały rejestr zmian danych biznesowych.",
      "entryCount": "Wpisy audytu",
      "storageSize": "Rozmiar zapisanych danych",
      "search": "Szukaj osoby, zdarzenia, zasobu lub ID...",
      "allSources": "Wszystkie źródła",
      "allActions": "Wszystkie działania",
      "dateFrom": "Data od",
      "dateTo": "Data do",
      "resourceType": "Typ zasobu",
      "applyFilters": "Zastosuj filtry",
      "clearFilters": "Wyczyść filtry",
      "timestamp": "Czas",
      "source": "Źródło",
      "actor": "Wykonawca",
      "action": "Działanie",
      "resource": "Zasób",
      "resourceIds": "ID zasobów",
      "changes": "Zmiany",
      "loading": "Ładowanie historii audytu...",
      "automated": "Operacja automatyczna",
      "totalEntries": "Liczba wpisów: {count}",
      "detailsTitle": "Szczegóły wpisu audytu",
      "field": "Pole",
      "before": "Przed",
      "after": "Po",
      "export": "Eksportuj CSV",
      "exportSuccess": "Historia audytu została wyeksportowana.",
      "exportError": "Nie udało się wyeksportować historii audytu.",
      "clear": "Wyczyść całą historię",
      "clearTitle": "Wyczyścić całą historię audytu?",
      "clearDescription": "Ta operacja trwale usunie wszystkie istniejące wpisy. Pozostanie jeden wpis potwierdzający wykonanie operacji.",
      "clearConfirmation": "Wpisz CLEAR, aby potwierdzić.",
      "clearSuccess": "Usunięto wpisy audytu: {count}.",
      "clearError": "Nie udało się wyczyścić historii audytu.",
      "sources": {
        "admin_api": "Panel administratora",
        "django_admin": "Panel Django",
        "customer": "Klient",
        "payment_provider": "Operator płatności",
        "system": "System"
      },
      "actions": {
        "create": "Utworzono",
        "update": "Zaktualizowano",
        "delete": "Usunięto",
        "import": "Zaimportowano",
        "export": "Wyeksportowano",
        "clear": "Wyczyszczono"
      }
    },
    "columns": {
      "id": "ID",
      "name": "Imię i nazwisko",
      "firstName": "Imię",
      "lastName": "Nazwisko",
      "phoneNumber": "Numer telefonu",
      "street": "Ulica",
      "buildingNumber": "Numer budynku",
      "apartmentNumber": "Numer mieszkania",
      "city": "Miasto",
      "driver": "Kierowca",
      "status": "Status",
      "paymentStatus": "Status płatności",
      "mapOrder": "Punkt",
      "amountKg": "Ilość (kg)",
      "type": "Typ",
      "preferredDay": "Preferowany dzień",
      "preferredTime": "Preferowana godzina",
      "address": "Adres",
      "actions": "Akcje",
      "stops": "Przystanki",
      "routeDuration": "Czas trwania",
      "createdAt": "Utworzono",
      "timestamp": "Znacznik czasu",
      "visitedAt": "Czas odwiedzenia",
      "skipped": "Pominięty",
      "driverName": "Kierowca",
      "assigned": "Przypisany",
      "notAssigned": "Nieprzypisany",
      "district": "Dzielnica"
    },
    "actions": {
      "view": "Podgląd",
      "edit": "Edytuj",
      "delete": "Usuń",
      "confirmTitle": "Czy na pewno chcesz kontynuować?",
      "confirmDescription": "Ta akcja usunie ten element.",
      "deleteSuccess": "Pomyślnie usunięto",
      "deleteError": "Nie udało się usunąć"
    },
    "auth": {
      "login": "Logowanie",
      "email": "E-mail",
      "password": "Hasło",
      "loginWithGoogle": "Zaloguj przez Google",
      "loginFailed": "Logowanie nie powiodło się.",
      "googleLoginFailed": "Logowanie przez Google nie powiodło się.",
      "redirectLoginFailed": "Logowanie przez przekierowanie nie powiodło się.",
      "notWhitelisted": "Nie masz konta w panelu administracyjnym.",
      "changePassword": "Zmień hasło",
      "changePasswordTitle": "Zmiana hasła",
      "changePasswordDescription": "Podaj obecne hasło, a następnie wpisz dwukrotnie nowe hasło.",
      "currentPassword": "Obecne hasło",
      "newPassword": "Nowe hasło",
      "confirmNewPassword": "Powtórz nowe hasło",
      "currentPasswordInvalid": "Obecne hasło jest nieprawidłowe.",
      "newPasswordTooShort": "Nowe hasło musi mieć co najmniej 12 znaków.",
      "newPasswordsDoNotMatch": "Nowe hasła nie są takie same.",
      "changePasswordTooManyRequests": "Wykonano zbyt wiele prób. Spróbuj ponownie później.",
      "changePasswordSuccess": "Hasło zostało zmienione.",
      "changePasswordError": "Nie udało się zmienić hasła. Spróbuj ponownie."
    },
    "settings": {
      "title": "Ustawienia",
      "description": "Zarządzaj preferencjami panelu administracyjnego.",
      "currentLocale": "Aktualny język",
      "languageEnglish": "Angielski",
      "languagePolish": "Polski",
      "switchToEnglish": "Przełącz na angielski",
      "switchToPolish": "Przełącz na polski",
      "seasonTitle": "Sezon borówkowy",
      "seasonDescription": "Ustaw daty sezonu, godzinę graniczną zamówień na dziś i dni bez dostaw.",
      "seasonOpeningDate": "Data rozpoczęcia sezonu",
      "seasonClosingDate": "Data zakończenia sezonu",
      "seasonTransitionDate": "Data zmiany komunikatu na przedsezonowy",
      "sameDayOrderCutoffTime": "Godzina graniczna zamówień na dziś",
      "blockedDeliveryDates": "Dni bez dostaw",
      "blockedDeliveryDateAdd": "Zablokuj dzień",
      "blockedDeliveryDateRemove": "Usuń zablokowany dzień {date}",
      "seasonCurrentStatus": "Aktualny status",
      "seasonStatusLoading": "Ładowanie",
      "seasonStatusUnknown": "Nieznany",
      "seasonStatusOpen": "Zamówienia otwarte",
      "seasonStatusBeforeStart": "Przed rozpoczęciem sezonu",
      "seasonStatusAfterEnd": "Po zakończeniu sezonu",
      "seasonSave": "Zapisz ustawienia zamówień",
      "seasonSaveSuccess": "Ustawienia zamówień zostały zapisane.",
      "seasonSaveError": "Nie udało się zapisać ustawień zamówień.",
      "seasonValidationError": "Popraw ustawienia zamówień przed zapisem.",
      "seasonOpeningRequired": "Data rozpoczęcia sezonu jest wymagana.",
      "seasonClosingRequired": "Data zakończenia sezonu jest wymagana.",
      "seasonTransitionRequired": "Data zmiany komunikatu jest wymagana.",
      "sameDayOrderCutoffRequired": "Wprowadź prawidłową godzinę graniczną zamówień na dziś.",
      "seasonTransitionBeforeOpening": "Data zmiany komunikatu musi być wcześniejsza lub równa dacie rozpoczęcia sezonu.",
      "seasonOpeningBeforeClosing": "Data rozpoczęcia sezonu musi być wcześniejsza lub równa dacie zakończenia sezonu.",
      "adminOrderEmailsTitle": "Powiadomienia e-mail o nowych zamówieniach",
      "adminOrderEmailsDescription": "Wybierz, czy po złożeniu nowego zamówienia wysyłać kopie do administratorów, i zarządzaj listą adresową.",
      "adminOrderEmailsToggleLabel": "Wysyłaj e-maile o nowych zamówieniach na listę administratorów",
      "adminOrderEmailRecipients": "Lista adresowa",
      "adminOrderEmailRecipientsPlaceholder": "admin{'@'}example.com\nzamowienia{'@'}example.com",
      "adminOrderEmailsSave": "Zapisz ustawienia e-mail",
      "adminOrderEmailsSaving": "Zapisywanie...",
      "adminOrderEmailsSaveSuccess": "Ustawienia e-maili o nowych zamówieniach zostały zapisane.",
      "adminOrderEmailsSaveError": "Nie udało się zapisać ustawień e-maili o nowych zamówieniach.",
      "adminOrderEmailsLoadError": "Nie udało się wczytać ustawień e-maili o nowych zamówieniach.",
      "adminOrderEmailRecipientsRequired": "Dodaj co najmniej jeden adres do listy.",
      "adminOrderEmailRecipientsInvalid": "Wprowadź wyłącznie prawidłowe adresy e-mail."
    }
  },

  "api": {
    "throttled": "Zbyt wiele żądań",
    "throttledDesc": "Wysyłasz żądania zbyt szybko. Poczekaj chwilę i spróbuj ponownie.",
    "throttledDescWithRetry": "Wysyłasz żądania zbyt szybko. Odczekaj {seconds} s i spróbuj ponownie.",
    "notFound": "Nie znaleziono zasobu.",
    "recaptchaFailed": "Weryfikacja reCAPTCHA nie powiodła się.",
    "unauthorized": "Nie masz uprawnień do wykonania tej akcji.",
    "somethingWentWrong": "Coś poszło nie tak.",
    "unknown": "Wystąpił nieznany błąd. Spróbuj ponownie później.",
    "invalidData": "Niepoprawnie sformatowane dane."
  },

  "validation": {
    "field": {
      "required": "To pole jest wymagane",
      "tooShort": "To pole jest za krótkie",
      "tooLong": "To pole jest za długie",
      "invalidEmail": "Nieprawidłowy adres e-mail"
    },
    "order": {
      "first_name": "Imię jest wymagane",
      "last_name": "Nazwisko jest wymagane",
      "street_name": "Ulica jest wymagana",
      "city_name": "Miasto jest wymagane",
      "postal_code": "Kod pocztowy jest wymagany",
      "postal_code_format": "Nieprawidłowy kod pocztowy",
      "address_area_required": "Podaj przynajmniej jedno z: kod pocztowy, miasto lub dzielnica",
      "phone_prefix": "Numer telefonu musi zaczynać się od + z kodem kraju",
      "phone_digits_only": "Nieprawidłowy numer telefonu",
      "phone_too_short": "Numer telefonu jest za krótki",
      "phone_too_long": "Numer telefonu jest za długi",
      "invalid_phone": "Numer telefonu musi składać się tylko z cyfr (9\u201315 cyfr)",
      "email_required": "Adres e-mail jest wymagany",
      "invalid_email": "Nieprawidłowy adres e-mail",
      "location_type": "Wybierz właściwy typ lokalizacji",
      "preferred_date_past": "Data nie może być z przeszłości",
      "preferred_date_required_all": "Wybierz termin dostawy",
      "preferred_date_required": "Data dostawy jest wymagana przy zamówieniach do biura",
      "preferred_time_required": "Czas dostawy jest wymagany przy zamówieniach do biura",
      "preferred_date_required_pickup": "Data odbioru jest wymagana przy odbiorze osobistym",
      "preferred_time_required_pickup": "Czas odbioru jest wymagany przy odbiorze osobistym",
      "quantity_min": "Minimalna ilość to 1 kg",
      "quantity_min_delivery": "Minimalna ilość dla dostawy to 2 kg",
      "quantity_integer": "Nieprawidłowa ilość"
    },
    "payment": {
      "method_required": "Wybierz metodę płatności"
    },
    "driver": {
      "color": "Podaj kolor w formacie HEX, np. #2563EB",
      "password": "Hasło musi mieć co najmniej 12 znaków"
    },
    "common": {
      "invalid": "Nieprawidłowe dane",
      "too_small": "Wartość jest za mała (min. {min})",
      "too_big": "Wartość jest za duża (max. {max})",
      "invalid_string": "Nieprawidłowy format tekstu",
      "invalid_type": "Nieprawidłowy format danych",
      "invalid_email": "Nieprawidłowy adres e-mail",
      "unrecognized_keys": "Nieznane pole w danych"
    }
  }
}
